import { RootState } from 'modules'
import { IBot } from 'pages/App/components/Sidebar/SidebarInfo/Bots'

export const selectBotList = (state: RootState): Array<IBot> | null =>
  state.bots.list

export const selectBotFetchedStatus = (state: RootState): boolean =>
  state.bots.fetched
